import { chatTieneSolicitud } from '../../shared/helpers/chat-tiene-pendiente';
import { ChatConversacion, SolicitudTipo } from '../../shared/interfaces/chat.interface';

export type CelulaPedidoTipo = 'eliminacion' | 'estudio' | 'bautismo' | 'nivel' | 'bajaBautismo';

export interface CelulaPedido {
  tipo: CelulaPedidoTipo;
  label: string;
  icono: string;
  header: string;
  texto: string;
  aceptar: string;
  exito: string;
}

export interface CelulaAviso {
  id: string;
  icono: string;
  texto: string;
  eliminar?: boolean;
}

export interface CelulaContexto {
  setLevel: number;
  cantCulto: number;
}

const SOLICITUD_DE: Record<Exclude<CelulaPedidoTipo, 'eliminacion' | 'bajaBautismo'>, SolicitudTipo> = {
  estudio: 'estudio',
  bautismo: 'bautismo',
  nivel: 'nivel',
};

export function puedePedirEstudio(setLevel: number, nivelPersonal: number): boolean {
  return (setLevel === 2 && nivelPersonal === 1) || (setLevel === 3 && nivelPersonal === 1);
}

export function puedePedirNivel(setLevel: number, nivelPersonal: number): boolean {
  return (
    (setLevel === 1 && nivelPersonal <= 3) ||
    (setLevel === 2 && nivelPersonal === 3) ||
    (setLevel === 3 && (nivelPersonal === 2 || nivelPersonal === 3))
  );
}

export function pedidosDisponibles(conversacion: ChatConversacion, setLevel: number): CelulaPedido[] {
  const pedidos: CelulaPedido[] = [];
  const nivel = conversacion.nivelPersonal;

  if (puedePedirEstudio(setLevel, nivel) && !chatTieneSolicitud(conversacion, 'estudio')) {
    pedidos.push({
      tipo: 'estudio',
      label: 'Solicitar estudio',
      icono: 'pi pi-book',
      header: 'Solicitar estudio',
      texto: '¿Qué estudio quiere comenzar el discípulo?',
      aceptar: 'Enviar',
      exito: 'Enviada.',
    });
  }

  if (puedePedirNivel(setLevel, nivel) && !chatTieneSolicitud(conversacion, 'nivel')) {
    pedidos.push({
      tipo: 'nivel',
      label: 'Solicitar nivel',
      icono: 'pi pi-arrow-up',
      header: 'Solicitar nivel',
      texto:
        'Exprese con sus palabras la razón por la cual cree que esta persona debería subir al siguiente nivel.',
      aceptar: 'Enviar',
      exito: 'Enviada.',
    });
  }

  if (!conversacion.bautizado && !conversacion.inscBautismo && !chatTieneSolicitud(conversacion, 'bautismo')) {
    pedidos.push({
      tipo: 'bautismo',
      label: 'Solicitar bautismo',
      icono: 'pi pi-heart',
      header: 'Solicitar bautismo',
      texto: '¿Desea agregar alguna aclaración a esta solicitud?',
      aceptar: 'Enviar',
      exito: 'Enviada.',
    });
  }

  return pedidos;
}

export function pedidoEliminar(nombre: string): CelulaPedido {
  return {
    tipo: 'eliminacion',
    label: 'Eliminar',
    icono: 'pi pi-trash',
    header: 'Eliminar',
    texto: `Describe la razón para eliminar a ${nombre}.`,
    aceptar: 'Solicitar eliminación',
    exito: 'Enviada.',
  };
}

export function celulaAvisos(conversacion: ChatConversacion, cantCulto: number): CelulaAviso[] {
  const avisos: CelulaAviso[] = [];

  const etiquetas: Record<SolicitudTipo, string> = {
    eliminar: 'Motivo de eliminación',
    nivel: 'Solicitud de nivel',
    estudio: 'Solicitud de estudio',
    bautismo: 'Solicitud de bautismo',
    bajaBautismo: 'Solicitud de baja de bautismo',
  };

  for (const solicitud of conversacion.solicitudes) {
    avisos.push({
      id: solicitud.tipo,
      icono: solicitud.tipo === 'eliminar' ? 'pi pi-exclamation-triangle' : 'pi pi-info-circle',
      texto: `${etiquetas[solicitud.tipo]}: ${solicitud.motivo || 'sin detalle.'}`,
      eliminar: solicitud.tipo === 'eliminar',
    });
  }

  if (conversacion.reunionSelect === 0 && cantCulto > 1) {
    avisos.push({
      id: 'reunion',
      icono: 'pi pi-question-circle',
      texto: 'Esta persona no está inscripta a ninguna reunión.',
    });
  }

  if (!conversacion.nacimiento) {
    avisos.push({
      id: 'nacimiento',
      icono: 'pi pi-question-circle',
      texto: 'Esta persona no tiene fecha de nacimiento.',
    });
  }

  return avisos;
}

export function solicitudDePedido(tipo: CelulaPedidoTipo): SolicitudTipo {
  if (tipo === 'eliminacion') {
    return 'eliminar';
  }
  if (tipo === 'bajaBautismo') {
    return 'bajaBautismo';
  }
  return SOLICITUD_DE[tipo];
}
